import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { PortalShell, FLD } from "@/pages/portal/PortalActivate";

export default function PortalReset() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const { applyToken } = useAuth();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return toast.error("Password must be at least 6 characters.");
    if (pw !== pw2) return toast.error("Passwords do not match.");
    setBusy(true);
    try {
      const { data } = await api.post("/portal/reset", { token, password: pw });
      toast.success("Password set — you're now logged in.");
      if (data.token) {
        await applyToken(data.token);
        const role = data.user?.role;
        nav(["parent", "student"].includes(role) ? "/portal" : role === "applicant" ? "/centre" : "/admin");
      } else { nav("/login"); }
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    setBusy(false);
  };

  return (
    <PortalShell>
      <div className="w-full max-w-md" data-testid="portal-reset">
        <h1 className="font-serif text-3xl text-paper">Set your password</h1>
        <p className="text-paper/50 text-sm mt-2">Set a password for your Simo account. Your email and any existing application stay linked — no new account is created.</p>
        {!token && <p className="text-amber-400 text-sm mt-4">This link is missing its token. Please use the button in your email.</p>}
        <form onSubmit={submit} className="mt-6 space-y-3">
          <input type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New password" data-testid="reset-pw" className={FLD} />
          <input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Confirm password" data-testid="reset-pw2" className={FLD} />
          <button disabled={busy || !token} data-testid="reset-submit" className="w-full bg-heraldic text-white rounded-sm py-3 text-sm inline-flex items-center justify-center gap-2 disabled:opacity-50">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <KeyRound className="h-4 w-4" />} Set password &amp; continue</button>
        </form>
        <p className="text-paper/40 text-xs mt-4"><Link to="/login" className="text-heraldic underline">Back to log in</Link></p>
      </div>
    </PortalShell>
  );
}
